module.exports = __webpack_public_path__ + "img/04-1.00289763.png";